import Modal from "react-bootstrap/Modal";
import {
  DeliveryMethod,
  useShoppingCart,
} from "../context/ShoppingCartContext";
import { pf } from "../utilities/helpers";
import React from "react";
import usePageLanguage from "../hooks/usePageLanguage";

interface Props {
  show: boolean;
  setShow: (val: boolean) => void;
  deliveryMethods?: DeliveryMethod[];
  onDeliveryMethodSelected?: (deliveryMethod: DeliveryMethod) => void;
  onCancel?: () => void;
}

export default function CheckoutSelectDeliveryMethodModal({
  show,
  setShow,
  deliveryMethods: deliveryMethodsProp,
  onDeliveryMethodSelected,
  onCancel,
}: Props) {
  const { deliveryMethods: deliveryMethodsFromContext } = useShoppingCart();
  const deliveryMethods = deliveryMethodsProp ?? deliveryMethodsFromContext;
  const lang = usePageLanguage();

  const handleDeliveryMethodClick = (deliveryMethod: DeliveryMethod) => {
    if (onDeliveryMethodSelected) {
      onDeliveryMethodSelected(deliveryMethod);
    }
  };

  const handleHide = () => {
    if (onCancel) {
      onCancel();
    } else {
      setShow(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleHide}
      contentClassName="modal-600 shop-controlled-border-radius"
    >
      <Modal.Header
        closeButton
        style={{
          borderTopLeftRadius: "var(--shop-border-radius)",
          borderTopRightRadius: "var(--shop-border-radius)",
        }}
      >
        <Modal.Title>
          <span className="badge badge-square badge-primary me-3">3</span>
          <span className="fw-bold">VALI TARNEVIIS</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {deliveryMethods
          ? deliveryMethods.map((deliveryMethod) => (
              <div
                key={deliveryMethod.uuid}
                className="col-xs-12 margin-bottom-10"
              >
                <button
                  className="btn btn-primary-outline text-left checkoutDeliveryButton"
                  style={{ width: "100%" }}
                  onClick={() => handleDeliveryMethodClick(deliveryMethod)}
                >
                  {deliveryMethod.translations?.[lang]?.name}
                  <span className="pull-right">
                    {" "}
                    {pf(Number(deliveryMethod.taxInclusivePriceAmount ?? 0))} &euro;
                  </span>
                </button>
              </div>
            ))
          : ""}
      </Modal.Body>
    </Modal>
  );
}
